import Tabla from "./tabla";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";

export default withRouter(withApollo(Tabla));
